/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import * as R from 'ramda';
import { Box, useMediaQuery } from '@mui/material';
import { useParams } from 'react-router-dom';
import LocationHeader from './header/LocationHeader';
import CardsDrawer from './CardsDrawer';
import TrailerCardList from './TrailerCardList';
import CreateTrailerWizard from './create-trailer-wizard/CreateTrailerWizard';
import EditTrailerDrawer from './EditTrailerDrawer';

const containerStyles = {
  bgcolor: 'surface.light',
  mt: { md: 6, xs: 0 },
  pb: { md: 0, xs: 8 },
  pl: { md: 37.5, xs: 1 },
  pr: { md: 0, xs: 1 },
};
const boxStyles = {
  display: 'grid',
  gap: 3,
  gridTemplateColumns: `repeat(auto-fit, 310px)`,
  ml: 3,
};

const defaultFilters = { expiration: 'Any', status: 'Any', trailer: '' };

const ViewTrailerDetailsByLocation = () => {
  const { viewById } = useParams();
  const lgUp = useMediaQuery(theme => theme.breakpoints.up('lg'), { noSsr: true });

  const [createTrailerOpened, openCreateTrailer] = useState(false);
  const [editTrailerId, setEditTrailerId] = useState('');
  const [cardsFilters, setCardsFilters] = useState(defaultFilters);

  const handleCreateTrailerOpen = R.compose(openCreateTrailer, R.T);
  const handleCreateTrailerClose = R.compose(openCreateTrailer, R.F);
  const handleEditTrailerClose = R.compose(setEditTrailerId, R.always(''));

  const handleResetFilters = () => {
    setCardsFilters(defaultFilters);
  };

  const handleRemoveFilter = label => {
    setCardsFilters(current => R.assoc(label, defaultFilters[label], current));
  };

  return (
    <>
      {lgUp ? (
        <Box sx={containerStyles}>
          <LocationHeader
            cardsFilters={cardsFilters}
            defaultFiltersState={defaultFilters}
            onCreateTrailer={handleCreateTrailerOpen}
            onRemoveFilter={handleRemoveFilter}
            onResetFilters={handleResetFilters}
            setCardsFilters={setCardsFilters}
          />
          <Box sx={boxStyles}>
            <TrailerCardList
              expFilterValue={cardsFilters.expiration}
              setEditTrailerId={setEditTrailerId}
              statusFilterValue={cardsFilters.status}
              vtcFilterValue={cardsFilters.trailer}
            />
          </Box>
        </Box>
      ) : (
        <CardsDrawer
          backlabel="Back to Locations"
          cardsFilters={cardsFilters}
          onCreateTrailer={handleCreateTrailerOpen}
          onResetFilters={handleResetFilters}
          open={!!viewById}
          setCardsFilters={setCardsFilters}
        >
          <TrailerCardList
            expFilterValue={cardsFilters.expiration}
            setEditTrailerId={setEditTrailerId}
            statusFilterValue={cardsFilters.status}
            vtcFilterValue={cardsFilters.trailer}
          />
        </CardsDrawer>
      )}
      {createTrailerOpened && <CreateTrailerWizard onClose={handleCreateTrailerClose} />}
      {editTrailerId && (
        <EditTrailerDrawer onClose={handleEditTrailerClose} trailerId={editTrailerId} />
      )}
    </>
  );
};

export default ViewTrailerDetailsByLocation;
